<div
    data-automation="externalPointsForm"
    class="form-container"
    id="externalPointsForm"
    *ngIf="externalPointsForm"
    [formGroup]="externalPointsForm"
>
    <!-- Name -->
    <div class="form-entry">
        <multi-locale-input
            formControlName="displayLabels"
            [inputLabel]="nameLabel"
            [locales]="supportedLocales"
            [displayLabelKey]="localeConfig?.displayLabelKey"
            [localeKey]="localeConfig?.localeKey"
            [defaultLocale]="localeConfig?.defaultLocale"
            [placeholderText]="namePlaceholder"
            [required]="true"
            [id]="getDisplayLabelsId()"
            data-automation="externalPointNameInput"
        >
        </multi-locale-input>
    </div>

    <!-- Data Provider -->
    <div class="form-entry">
        <mat-form-field appearance="outline">
            <mat-label>
                <mat-label>{{ 'external.point.data_provider' | translate }}</mat-label></mat-label
            >
            <mat-select data-automation="dataProviderDropdown" formControlName="dataproviderId" required>
                <mat-option *ngFor="let p of providers" [value]="p.id">
                    {{ p.displayLabel }}
                </mat-option>
            </mat-select>
            <mat-error
                data-automation="dataProviderError"
                *ngIf="externalPointsForm.get('dataproviderId')?.hasError('required')"
            >
                {{ 'utility.account.validation.required' | translate }}
            </mat-error>
        </mat-form-field>
    </div>

    <!-- Channel -->
    <div class="form-entry">
        <mat-form-field appearance="outline">
            <mat-label>{{ 'external.point.channel' | translate }}</mat-label>
            <mat-select
                data-automation="channelDropdown"
                formControlName="channelId"
                required
                (selectionChange)="onChannelSelection($event.value)"
            >
                <mat-option *ngFor="let c of channels" [value]="c.id">
                    {{ c.displayLabel }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="externalPointsForm.get('channelId')?.hasError('required')">
                {{ 'utility.account.validation.required' | translate }}
            </mat-error>
        </mat-form-field>
    </div>

    <!-- Reporting Interval -->
    <div class="form-entry">
        <mat-form-field appearance="outline">
            <mat-label>{{ 'external.point.reporting_interval' | translate }}</mat-label>
            <mat-select data-automation="reportingIntervalDropdown" formControlName="reportingInterval" required>
                <mat-option *ngFor="let i of reportingIntervals" [value]="i.id">
                    {{ i.displayLabel }}
                </mat-option>
            </mat-select>
            <mat-error
                *ngIf="externalPointsForm.get('reportingInterval')?.hasError('required')"
                data-automation="reportingIntervalError"
            >
                {{ 'utility.account.validation.required' | translate }}
            </mat-error>
        </mat-form-field>
    </div>

    <!-- Source ID -->
    <div class="form-entry">
        <mat-form-field appearance="outline">
            <mat-label>{{ 'external.point.source_id' | translate }}</mat-label>

            <input
                data-automation="sourceIdInput"
                matInput
                formControlName="sourceId"
                required
                [errorStateMatcher]="sourceIdErrorMatcher"
            />

            <mat-error
                *ngIf="externalPointsForm.get('sourceId')?.hasError('required')"
                data-automation="sourceIdEmptyError"
            >
                {{ 'utility.account.validation.required' | translate }}
            </mat-error>

            <mat-error
                *ngIf="externalPointsForm.get('sourceId')?.hasError('duplicateInSiblings')"
                data-automation="sourceIdPatternError"
            >
                {{ 'utility.account.validation.source_id_unique' | translate }}
            </mat-error>

            <mat-error *ngIf="externalPointsForm.get('sourceId')?.hasError('minlength')">
                <span data-automation="sourceIdPatternError">
                    {{ 'external.point.validation.minLength' | translate }}
                    ({{ externalPointsForm.get('sourceId')?.errors?.minlength?.actualLength }}
                    /
                    {{ externalPointsForm.get('sourceId')?.errors?.minlength?.requiredLength }})
                </span>
            </mat-error>

            <mat-error
                *ngIf="externalPointsForm.get('sourceId')?.hasError('maxlength')"
                data-automation="sourceIdPatternError"
            >
                {{ 'external.point.validation.maxLength' | translate }}
            </mat-error>

            <mat-error
                *ngIf="externalPointsForm.get('sourceId')?.hasError('pattern')"
                data-automation="sourceIdPatternError"
            >
                {{ 'external.point.validation.pattern' | translate }}
            </mat-error>
        </mat-form-field>
    </div>

    <!-- Expression Factor -->
    <div class="form-entry">
        <mat-form-field appearance="outline">
            <mat-label>{{ 'external.point.expression_factor' | translate }}</mat-label>
            <input
                matInput
                type="number"
                formControlName="expressionFactor"
                required
                step="1"
                min="1"
                inputmode="numeric"
                data-automation="expressionFactorInput"
                appNumberOnly
            />
            <mat-error *ngIf="externalPointsForm.get('expressionFactor')?.hasError('required')">
                {{ 'utility.account.validation.required' | translate }}
            </mat-error>
            <mat-error *ngIf="externalPointsForm.get('expressionFactor')?.hasError('min')">
                {{ 'utility.account.validation.required' | translate }}
            </mat-error>
        </mat-form-field>
    </div>

    <!-- VEE Bypass -->
    <div class="form-entry">
        <div class="checkbox-wrapper">
            <label class="vee-bypass-label">
                <!-- 
                We don't use mat-checkbox because enel-tree overrides the styles. 
                It's not possible to use a different workaround since sometimes enel-tree loads later 
                and still overrides the mat-checkbox styles. That's why we've kept the native input. 
                -->
                <input
                    type="checkbox"
                    id="veeBypass_{{ index }}"
                    name="veeBypass_{{ index }}"
                    formControlName="veeBypass"
                    [checked]="externalPointsForm.get('veeBypass')?.value"
                    data-automation="veeBypass"
                    data-url-persist
                    class="vee-bypass-checkbox"
                />
                <span>{{ 'utility.account.create.eternal_points.set_vee_bypass' | translate }}</span>
            </label>
        </div>
    </div>
</div>
